import React, { useState } from "react";
import { Box, Button, IconButton, Popover, Stack, TextField, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";

import { DealStageItem } from "store/types";
import { useDidUpdate } from "hooks";

interface Props {
  anchorEl?: HTMLButtonElement;
  dealStageItem?: DealStageItem;
  stageId?: number;
  handleClose: () => void;
  onSubmit: (value: string) => Promise<void>;
}

export const NotePopup: React.FC<Props> = ({ anchorEl, dealStageItem, handleClose, onSubmit }) => {
  const [noteValue, setNoteValue] = useState<string>("");

  const { deal_note, title } = dealStageItem || {};
  const { note } = deal_note || {};

  useDidUpdate(() => {
    if (anchorEl && note) {
      setNoteValue(note);
    }
    if (!anchorEl) {
      setNoteValue("");
    }
  }, [anchorEl]);

  return (
    <Popover
      {...(anchorEl && { id: "deal-note" })}
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left"
      }}
    >
      <Box sx={{ width: "412px", p: "20px", borderRadius: "8px", color: "#0a3142" }}>
        <Stack gap="20px">
          <Stack
            sx={{ borderBottom: "1px solid #dae0e2", pb: "2px" }}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography sx={{ fontSize: "16px" }}>My note: {title}</Typography>
            <IconButton sx={{ padding: "3px" }} onClick={handleClose}>
              <Close sx={{ fontSize: "20px", color: "#5d7782" }} />
            </IconButton>
          </Stack>
          <TextField
            value={noteValue}
            onChange={(e) => setNoteValue(e.target.value)}
            label="Edit note"
            multiline
            minRows={3}
            maxRows={10}
          />
          <Stack alignItems="flex-end">
            <Button
              disabled={Boolean(note && note === noteValue)}
              variant="contained"
              onClick={() => {
                onSubmit(noteValue);
                handleClose();
              }}
            >
              Save
            </Button>
          </Stack>
        </Stack>
      </Box>
    </Popover>
  );
};
